import React, { useState } from "react";
// import { styled } from '@mui/material/styles';
import COLOR from "utils/constants/color";
import VideoPicker from "components/AdminBooks/VideoPicker";
import VideoRecorder from "features/VideoRecorderNew";
import styled from "styled-components";
import { RECORDER_TYPE, VIDEO_DURATIONS } from "utils/config/reference";
import { handleAudioTranscript } from "store/submissions/thunks";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { makeStyles } from "@mui/styles";

const AssignmentVideo = (props) => {
  const classes = useStyles();
  const {
    index,
    question,
    isAssigned,
    create_new_copy,
    assignedloading,
    from = "",

    setVideoRecording = () => {},
    showRemoveVideoButton = false,
  } = props?.states || {};
  const {
    onChangeQuestionData,
    setButtonDisabled,
    handleDeleteAudioVideo = () => {},
    trenacriptAudio,
  } = props?.funcObj;
  const [dropdownStates, setDropdownStates] = useState({
    duration: question?.duration ? question?.duration : "60",
    index: index,
    videoType: question?.videoType
      ? question?.videoType || "recorder"
      : "recorder",
  });
  const transcriptVideo = (url) => {
    if (!url) return;
    if (trenacriptAudio) {
      trenacriptAudio(url);
    } else {
      handleAudioTranscript(url);
    }
  };
  const handleDropdownChange = (field, value) => {
    setDropdownStates((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <>
      {from === "instruction" ? null : (
        <Question style={{ marginBottom: 16 }}>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id={`durations-${index}`}>Time</InputLabel>
            <Select
              labelId={`durations-${index}`}
              id={`durations-${index}`}
              value={question.duration || "60"}
              disabled={(isAssigned && !create_new_copy) || assignedloading}
              required
              onChange={(e) => {
                handleDropdownChange("duration", e.target.value);
                onChangeQuestionData(e.target.value, "duration", index);
              }}
              label="Time"
            >
              {VIDEO_DURATIONS.map((v) => (
                <MenuItem key={v.value} value={v.value}>
                  {v.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Question>
      )}

      {from === "instruction" ? null : (
        <Question style={{ marginBottom: 16 }}>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id={`video-type-${index}`}>
              Select Video Type
            </InputLabel>
            <Select
              labelId={`video-type-${index}`}
              id={`video-type-${index}`}
              value={dropdownStates?.videoType || "Record"}
              required
              onChange={(e) => {
                handleDropdownChange("videoType", e.target.value);
                onChangeQuestionData(e.target.value, "videoType", index);
              }}
              label="Select Video Type"
            >
              {RECORDER_TYPE.map((v) => (
                <MenuItem key={v.id} value={v.value}>
                  {v.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Question>
      )}

      {dropdownStates?.index === index &&
        dropdownStates?.videoType === "recorder" && (
          <Question style={{ marginBottom: 16 }}>
            <VideoRecorder
              handleVideo={(v) => {
                onChangeQuestionData(v, "video", index);
                if (v) {
                  transcriptVideo(v);
                }
              }}
              videoSource={question.video}
              index={index}
              hasSaveButton
              message={`Record a question`}
              setButtonDisabled={(value) => setButtonDisabled(value)}
              maxTime={
                from === "instruction"
                  ? "60"
                  : dropdownStates.duration || question.duration || 20
              }
              isRecordingStatus={(v) => setVideoRecording(v)}
              handleDeleteAudioVideo={handleDeleteAudioVideo}
              from={from}
              showRemoveVideoButton={showRemoveVideoButton}
            />
          </Question>
        )}

      {dropdownStates.index === index &&
        dropdownStates.videoType === "uploader" && (
          <Question style={{ marginBottom: 16 }}>
            <VideoPicker
              src={question.video}
              maxTime={dropdownStates.duration || question.duration || 20}
              message={"Upload a video file for question..."}
              onChange={(v) => {
                onChangeQuestionData(v?.url, "video", index);
                transcriptVideo(v?.url);
              }}
              setButtonDisabled={(value) => setButtonDisabled(value)}
            />
          </Question>
        )}

      {/* {from === "instruction" ? null : (
        <Question style={{ marginBottom: 16 }}>
          <VideoRecorder
            maxTime={dropdownStates.duration || question.duration || 20}
            handleVideo={() => {}}
            index={index}
            isPreview
            setButtonDisabled={(value) => setButtonDisabled(value)}
          />
        </Question>
      )} */}

    </>
  );
};
export default AssignmentVideo;

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "25px",
    width: "300px",
  },
  rootDif: {
    width: "200px",
  },
  rootDifFull: {
    width: "100%",
  },
  sizeSmall: {
    width: "55px",
    height: "25px",
  },
  checkedSwitch: {
    transform: "translateX(30px) !important",
  },
  label: {
    textTransform: "uppercase",
  },
  formControl: {
    minWidth: 120,
  },
  colorPrimary: {
    color: `${COLOR.green}!important`,
  },
}));

const Container = styled.div`
  width: 100%;
`;

const AssignmentTitle = styled.span`
  color: ${COLOR.black100};
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
`;

const Question = styled(AssignmentTitle)`
  font-size: 16px;
  line-height: 22px;
  margin-top: 10px;
`;
